import { gql } from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';

import { GetPointOfInterest, GetPointOfInterestVariables } from '@generated/graphql';
import { PointOfInterestFragments } from '@graphql/fragments/rutilus/PointOfInterestType';

export const getPointOfInterest: TypedDocumentNode<
  GetPointOfInterest,
  GetPointOfInterestVariables
> = gql`
  query GetPointOfInterest($id: Int) {
    entry: pointOfInterest(id: $id) {
      ...PointOfInterestId
      address
      city
      country
      county
      description
      email
      phone
      primaryName
      rampSurface
      rampType
      state
      website
      zipcode
      primaryType
    }
  }
  ${PointOfInterestFragments.id}
`;
